import { render, staticRenderFns } from "./AiTaskChat.vue?vue&type=template&id=3b86d15f&scoped=true"
import script from "./AiTaskChat.vue?vue&type=script&lang=js"
export * from "./AiTaskChat.vue?vue&type=script&lang=js"
import style0 from "./AiTaskChat.vue?vue&type=style&index=0&id=3b86d15f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86d15f",
  null
  
)

export default component.exports